<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">委托人指南 (CLI)</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">安装exchaincli</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">FAX 账户</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">创建账户</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">访问 Fax 网络</a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">设置 exchaincli</a></p>
          <p @click="activeted(7)" class="s1"><a :class="{active:flag==7}" href="#box7">查询状态</a></p>
          <p @click="activeted(8)" class="s1"><a :class="{active:flag==8}" href="#box8">发送交易</a></p>
          <p @click="activeted(9)" class="s1"><a :class="{active:flag==9}" href="#box9">参与治理</a></p>
          <!-- <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">2222222</a></p> -->
          <div class="subAnchor">
            <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->
    
          </div>
        </div>
      </div>
      <div id="box1" class="p1">委托人指南 (CLI)</div>
      <div class="p3">本文档包含委托人通过命令行界面 (CLI) 与 Fax 交互的所有必要信息。</div>
      <div class="p3">注意：请确保您仔细遵循下文所述的步骤，因为此过程中的疏忽可能导致您的Fax 无限期丢失。因此，请在继续之前仔细完整地阅读以下说明，并在需要支持时联系我们。</div>
      <div class="p3">另请注意，您即将与 Fax 进行交互，Fax 是一种包含高度实验性软件的区块链技术。虽然区块链是按照最先进的方法开发并经过极其谨慎的审核，但我们仍然可以预期会有问题、更新和错误。此外，与区块链技术的交互需要先进的技术技能，并且总是会带来我们无法控制的风险。请格外小心！</div>
      <div id="box2" class="p2">安装exchaincli</div>
      <div class="p3"><span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">exchaincli</span> ：这是与 exchaind 全节点交互的命令行界面。</div>
      <div class="p3">注意： 请检查您是否下载了exchaincli可用的最新稳定版本</div>
      <div class="p3">[下载二进制文件] 尚不可用。</div>
      <div class="p3"><span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">exchaincli</span> 从终端使用。要打开终端，请按照下列步骤操作：</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>
            窗户：
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Start</span>  >>> _ _
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">All ProgramsAccessories</span> 
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Command Prompt</span> 
          </li>
          <li>
            macOS : 
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Finder</span>  > 
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Applications</span>  > 
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Utilities</span>  >
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Terminal</span> 
          </li>
          <li>
            Linux : 
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Ctrl</span> + 
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">Alt</span> +
            <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">T</span> 
          </li>
        </ul>
      </div>
      <div id="box3" class="p2">FAX 账户</div>
      <div class="p3">每个 FaxChain 账户的核心都有一个种子，它采用 12 字助记符的形式。通过这个助记词，可以创建任意数量的 FaxChain 账户，即一对私钥/公钥。</div>
      <div class="p3">存储在帐户中的资金由私钥控制。此私钥是使用助记符中的单向函数生成的。如果您丢失了私钥，您可以使用助记符找回它。但是，如果您丢失了助记符，您将无法访问所有派生的私钥。同样，如果有人可以访问您的助记词，他们就可以访问所有相关帐户。</div>
      <div class="p3">注意： 不要丢失或与任何人分享您的 12 个单词。为防止资金被盗或丢失，最好确保您保留多个助记词副本，并将其存放在安全可靠的地方，并且只有您知道如何访问它。如果有人能够访问您的助记词，他们将能够访问您的私钥并控制与他们关联的帐户。</div>
      <div id="box4" class="p2">创建账户</div>
      <div class="p3">要创建一个帐户，您只需要 <span style="padding:2px 5px;color:red;border:1px solid #ccc;font-size:12px">exchaincl</span> 安装。在创建它之前，您需要知道您打算在哪里存储并与您的私钥交互。最好的选择是将它们存储在离线专用计算机或硬件钱包中。将它们存储在您的常规在线计算机上会带来更大的风险，因为通过互联网渗透到您计算机的任何人都可能泄露您的私钥并窃取您的资金。</div>
      <div class="p3">要生成帐户，只需使用以下命令：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli keys add < yourKeyName > </div>
        </div>
      </div>
      <div class="p3">该命令会生成一个 12 字的助记词，同时保存账户的私钥和公钥。每次您要发送交易时，都需要解锁系统的凭证存储。如果您无法访问凭证存储，您始终可以使用助记符恢复私钥。</div>
      <div class="p3">您可能不需要在每次发送交易时都提供密码，因为大多数操作系统默认会在登录时解锁用户的凭据。如果您想更改您的凭据安全策略，请参阅您的操作系统手册。不要丢失或与任何人分享您的 12 个单词。为防止资金被盗或丢失，最好确保您保留多份助记词，并将其存放在安全、可靠且只有您知道如何访问的地方。如果有人能够访问您的助记词，他们将能够访问您的私钥并控制与他们关联的帐户。</div>
      <div class="p3">在确保您的助记符（三重检查！）之后，您可以删除您的 bash 历史记录以确保没有人可以检索它：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">history -c</div>
          <div style="padding:5px 0">rm ~/.bash_history</div>
        </div>
      </div>

      <div class="p3">您可以使用以下命令从同一个助记词生成更多帐户：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli keys add < yourKeyName > --recover --account 1</div>
        </div>
      </div>
      <div class="p3">此命令将提示您输入密码和助记符。</div>

      <div id="box5" class="p2">访问 Fax 网络</div>
      <div class="p3">为了查询状态并发送交易，您需要一种访问网络的方法。为此，您可以运行自己的完整节点，也可以连接到其他人的。</div>
      <div class="p3">注意：不要与任何人分享您的助记符（12 个单词）。唯一需要知道的人就是你。如果有人通过电子邮件或直接消息与您联系，要求您分享您的助记符以获得任何类型的区块链服务或支持，这一点尤其重要。来自 FaxChain、Tendermint 团队或 Interchain 基金会的任何人都不会发送一封电子邮件，要求您分享任何类型的帐户凭据或助记词。</div>
      <div class="p4">连接到远程全节点</div>
      <div class="p3">如果您不想或无法运行自己的节点，您可以连接到其他人的全节点。您应该选择您信任的运营商，因为恶意运营商可能会返回错误的查询结果或审查您的交易。但是，他们永远无法窃取您的资金，因为您的私钥存储在本地计算机或硬件钱包中。全节点运营商的可能选项包括验证器、钱包提供商或交易所。为了连接到全节点，您需要以下形式的地址：（https://35.176.62.211:26657 注意：这是一个占位符）。该地址必须由您选择信任的全节点运营商传达。</div>
      
      <div id="box6" class="p2">设置 exchaincli</div>
      <div class="p3">在设置之前 exchaincli，请确保您已经设置了 exchaind。</div>
      <div class="p3">exchaincli 是使您能够与在 fax 网络上运行的节点进行交互的工具.</div>
      <div class="p3">为了设置 exchaincli，请使用以下命令：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli config < flag > < value ></div>
        </div>
      </div>
      <div class="p3">它允许您为每个给定标志设置默认值。</div>
      <div class="p3">首先，设置要连接的全节点地址：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli config node < host >:< port</div>
          <div style="padding:5px 0">// example: exchaincli config node tcp://localhost:26657</div>
        </div>
      </div>
      <div class="p3">如果您运行自己的全节点，只需 tcp://localhost:26657 用作地址。然后，设置--trust node 标志的默认值：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli config trust-node false</div>
          <div style="padding:5px 0">// Set to true if you run a light-client node, false otherwise</div>
        </div>
      </div>
      <div class="p3">最后，设置 chain-id 要与之交互的区块链：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli config chain-id filechain-778787</div>
        </div>
      </div>

      <div id="box7" class="p2">查询状态</div>
      <div class="p3">在绑定 Fax 和提取奖励之前，您需要设置 exchaincli</div>
      <div class="p3">exchaincli 让您可以查询区块链中的所有相关信息，例如账户余额、绑定代币数量（存入一个或多个验证者的 Fax）、未偿奖励、治理建议等。接下来是对委托人最有用的命令列表。</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">// query account balances and other account-related information</div>
          <div style="padding:5px 0">exchaincli query account < yourAddress ></div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// query the list of validators</div>
          <div style="padding:5px 0">exchaincli query staking validators</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// query the information of a validator given their address (e.g. fvaloper1alq9na49n9yycysh889rl90g9nhe58lcs50wu5)exchaincli query staking validator < validatorAddress ></div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// query all information of delegations and all shares recently added by a delegator (e.g. f1l69kwpvzhuypz2m5yv99xwtlpsdwclt7f6p23d)exchaincli query staking delegator < delegatorAddress ></div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// query the information of all shares recently added to a validator (e.g. fvaloper1l69kwpvzhuypz2m5yv99xwtlpsdwclt7csuap5)exchaincli query staking shares-added-to < validatorAddress ></div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// query the addresses of delegators by a specific proxy (e.g. f1l69kwpvzhuypz2m5yv99xwtlpsdwclt7f6p23d)exchaincli query staking proxy < proxyAddress ></div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// query all proposals currently open for depositing exchaincli query gov proposals --status deposit_period</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// query all proposals currently open for voting exchaincli query gov proposals --status voting_period</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// query a proposal given its proposalID</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaincli query gov proposal < proposalID ></div>
        </div>
      </div>
      <div class="p3">如需更多命令，只需键入：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli query</div>
        </div>
      </div>
      <div class="p3">对于每个命令，您可以使用-h 标志来获取更多信息。</div>


      <div id="box8" class="p2">发送交易</div>
      <div class="p3">在 Fax 测试网上，接受的 denom 是 Fax，如果您需要获取 Fax，您可以在这里获取。</div>
      <div class="p4">关于 Gas 和费用的说明</div>
      <div class="p3">Fax 网络上的交易需要包含交易费用才能进行处理。这笔费用用于支付运行交易所需的gas。公式如下</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">fees = ceil(gas * gasPrices)</div>
        </div>
      </div>
      <div class="p3">gas 取决于交易。不同的交易需要不同的金额 gas。交易的 gas 金额是在处理过程中计算出来的，但是有一种方法可以通过使用标志的 auto 值来预先估计它。gas 当然，这只是一个估计。如果您想确保为交易提供足够的资金，您可以使用标志--gas-adjustment（默认）调整此估计。在本教程的其余部分，我们将使用--gas-adjustment 或者 1.5</div>
      <div class="p3">gasPrice 是每个单位的价格 gas。每个验证器都会设置一个 min-gas-price 值，并且只会包含gasPrice 大于其 min-gas-price.</div>
      <div class="p3">交易 fees 是 和 的 gas 乘积 gasPrice。作为用户，您必须输入 3 个中的2 个。gasPrice/fees越高，您的交易被包含在一个块中的机会就越高。</div>
      <div class="p3">对于 testnet，建议的 gasPrice 为 0.00000005fax</div>
      <div class="p4">发送 Tokens</div>
      <div class="p3">在绑定 Fax 和提取奖励之前，您需要设置 exchaincli 并创建一个帐户</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">// Send a certain amount of tokens to an address</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// Ex value for parameters (do not actually use these values in your tx!!):< to_address >=ex19n6w5l0htdgn2zwet9rtgvrzuf4a3qp4znwfcn < amount >=1024Fax</div>
          <div style="padding:5px 0">// Ex value for flags: < gasPrice >=0.005Fax</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaincli tx send < from_key_or_address > < to_address > < amount > --from < yourKeyName > --gas auto --gas-adjustment 1.5 --gas-prices < gasPrice ></div>
        </div>
      </div>
      <div class="p4">绑定 Faxs 和提现奖励</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">// Deposit an amount of Fax to delegator account. Deposited Fax in delegator account is aprerequisite for adding shares</div>
          <div style="padding:5px 0">// ex value for flags: < amountToDeposit >=1024Fax, < gasPrice >=0.005Fax</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaincli tx staking deposit < amountToDeposit > --from < delegatorKeyName > --gas auto--gas-adjustment 1.5 </div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// Add shares to one or more validators by all deposited Fax</div>
          <div style="padding:5px 0">// ex value for flags: < validator-addr >=fvaloper1alq9na49n9yycysh889rl90g9nhe58lcs50wu5 < gasPrice >=0.00000005Fax</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaincli tx staking add-shares < validator-addr > --from < delegatorKeyName > --gas auto--gas-adjustment 1.5 --gas-prices < gasPrice ></div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// Withdraw an amount of Fax and the corresponding shares from all validators.</div>
          <div style="padding:5px 0">// You will have to wait 3 weeks before your Faxs are fully unbonded and transferrable</div>
          <div style="padding:5px 0">// ex value for flags: < amountToWithdraw >=1024Fax, < gasPrice >=0.00000005Fax</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaincli tx staking withdraw < amountToWithdraw > --from < delegatorKeyName > --gas auto--gas-adjustment 1.5 --gas-prices < gasPrice ></div>

        </div>
      </div>
      <div class="p3">要确认您的交易已完成，您可以使用以下查询：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">// your balance should change after you bond Faxs or withdraw rewards exchaincli query account</div>
          <div style="padding:5px 0">// you should have delegations after you bond Fax exchaincli query staking delegator < delegatorAddress ></div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// this returns your tx if it has been included</div>
          <div style="padding:5px 0">// use the tx hash that was displayed when you created the tx</div>
          <div style="padding:5px 0">exchaincli query tx < txHash ></div>
        </div>
      </div>
      <div class="p3">如果您通过受信任的全节点与网络交互，请仔细检查区块浏览器。</div>


      <div id="box9" class="p2">参与治理</div>
      <div class="p4">治理入门</div>
      <div class="p3">Fax 有一个内置的治理系统，可以让绑定的 Fax 持有者对提案进行投票。提案分为三种类型：</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>Text Proposals: 这些是最基本的提案类型。它们可用于获取网络对给定主题的意见。</li>
          <li>Parameter Proposals：这些用于更新现有参数的值。</li>
          <li>Software Upgrade Proposal：这些用于建议升级中心的软件。</li>
        </ul>
      </div>
      <div class="p3">任何 Fax 持有者都可以提交提案。为了让提案公开投票，它需要带有一个deposit 大于称为参数的参数 minDeposit。提交者 deposit 不需要全部提供。如果初始提议者的deposit 数量不足，则该提议进入 deposit_period 状态。然后，任何 Fax 持有者都可以通过发送depositTx.</div>
      <div class="p3">一旦 deposit 达到 minDeposit，提案进入 voting_period，持续 2 周。然后，任何保税Fax 持有者都可以对该提案进行投票。选项是 Yes、No 和 NoWithVeto。Abstain 投票权重基于发送者的绑定 Fax 数量。如果他们不投票，委托人将继承其验证人的投票。但是，委托人可以通过自己发送投票来覆盖其验证人的投票。</div>
      <div class="p3">投票期结束时，得票超过 50% Yes（不含 Abstain 票）且未满 33.33% NoWithVeto（不含Abstain票）的提案为通过。</div>
      <div class="p4">实践</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">// Submit a Proposal</div>
          <div style="padding:5px 0">// < type >=text/parameter_change/software_upgrade</div>
          <div style="padding:5px 0">// ex value for flag: < gasPrice >=0.005Fax</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaincli tx gov submit-proposal --title "Test Proposal" --description "My awesome proposal"--type < type > --deposit=100Fax --gas auto --gas-adjustment 1.5 --gas-prices < gasPrice > --from< delegatorKeyName ></div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// Increase deposit of a proposal</div>
          <div style="padding:5px 0">// Retrieve proposalID from $exchaincli query gov proposals --status deposit_period</div>
          <div style="padding:5px 0">// ex value for parameter: < deposit >=100Fax</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaincli tx gov deposit < proposalID > < deposit > --gas auto --gas-adjustment 1.5 --gas-prices< gasPrice > --from < delegatorKeyName ></div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">// Vote on a proposal</div>
          <div style="padding:5px 0">// Retrieve proposalID from $exchaincli query gov proposals --status voting_period</div>
          <div style="padding:5px 0">// < option >=yes/no/no_with_veto/abstain</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaincli tx gov vote < proposalID > < option > --gas auto --gas-adjustment 1.5 --gas-prices< gasPrice > --from < delegatorKeyName ></div>
        </div>
      </div>
      <div class="p4">从离线计算机签署交易</div>
      <div class="p3">如果您没有硬件钱包并且想在离线计算机上与您的私钥进行交互，您可以使用以下过程。首先，使用以下命令在在线计算机上生成未签名的交易（以绑定交易为例）：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">// Bond Faxs</div>
          <div style="padding:5px 0">// ex value for flags: < amountToDeposit >=1024Fax, < gasPrice >=0.005Fax, < delegatorAddress >=ex19n6w5l0htdgn2zwet9rtgvrzuf4a3qp4znwfcn</div>
          <div style="padding:5px 0"></div>
          <div style="padding:5px 0">exchaincli tx staking deposit < amountToDeposit > --from < delegatorAddress > --gas auto--gas-adjustment 1.5 --gas-prices < gasPrice > --generate-only > unsignedTX.json</div>
        </div>
      </div>
      <div class="p3">为了签名，您还需要 chain-id,account-number 和 sequence。这 chain-id 是您提交交易的区块链的唯一标识符。这 account-number 是您的帐户首次收到资金时生成的标识符。该sequence号码用于跟踪您已发送的交易数量并防止重放攻击。</div>
      <div class="p3">从创世文件 ( ) 中获取链 ID Fax，并使用帐户查询获取其他两个字段：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli query account < yourAddress > --chain-id filechain-778787</div>
        </div>
      </div>
      <div class="p3">然后，将其复制 unsignedTx.json 并传输（例如通过 USB）到离线计算机。如果尚未完成，请在离线计算机上创建一个帐户。为了提高安全性，您可以在使用以下命令签署之前仔细检查您的交易参数：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">cat unsignedTx.json</div>
        </div>
      </div>
      <div class="p3">现在，使用以下命令签署交易。您将需要 chain-id,sequence 并 account-number 在之前获得：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx sign unsignedTx.json --from < delegatorKeyName > --offline --chain-idfilechain-778787 --sequence < sequence > --account-number < account-number > > signedTx.json</div>
        </div>
      </div>
      <div class="p3">将其复制 signedTx.json 并传输回在线计算机。最后，使用以下命令广播交易：</div>
      <div class="p3">
        <div style="padding:15px 10px;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">exchaincli tx broadcast signedTx.json</div>
        </div>
      </div>

    </div>
    


    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">委托人指南 (CLI)</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">安装exchaincli</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">FAX 账户</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">创建账户</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">访问 Fax 网络</a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">设置 exchaincli</a></p>
      <p @click="activeted(7)" class="s1"><a :class="{active:flag==7}" href="#box7">查询状态</a></p>
      <p @click="activeted(8)" class="s1"><a :class="{active:flag==8}" href="#box8">发送交易</a></p>
      <p @click="activeted(9)" class="s1"><a :class="{active:flag==9}" href="#box9">参与治理</a></p>
      <!-- <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">2222222</a></p> -->
      <div class="subAnchor">
        <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->

      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicAPI',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>